import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const reset = () => initialState;

const setFailureMessage = (state, { payload, meta }) => {
  if (meta.source === 'link-audit') {
    return payload;
  }
  return state;
};
export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_FAILURE]: setFailureMessage,
  [actionTypes.FETCH_AUDITS_REQUEST]: reset,
});
